
export default () => ({
  orderStatus: [],
  stores: [],
  storeWithLimits: [],
  generalSetting: null,
  getImageSlider: []
});
